import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import _ from 'lodash'
import moment from 'moment'
import numeral from 'numeral'
import PropTypes from 'prop-types'
import history from '../../history'
import ReactTable from 'react-table'
import Loader from '../../util/Loader'
import { ModalRoute } from 'react-router-modal'
import { filterCaseInsensitive } from '../../util'
import { Tooltip, Button, Popconfirm } from 'antd'
import { actions as revisionActions } from '../../redux/modules/revisionActions'
import { actions as itemActions } from '../../redux/modules/jobFunctions/itemActions'
import { actions as jobVendorActions } from '../../redux/modules/jobFunctions/jobVendorActions'
import { actions as leadEstimateActions } from '../../redux/modules/leadFunctions/leadEstimateActions'
import { actions as estimateTemplateActions } from '../../redux/modules/jobFunctions/estimateTemplateActions'
import { actions as jobSiteChangeOrderActions } from '../../redux/modules/jobFunctions/jobSiteChangeOrderActions'

import AddEditFormModal from './components/estimates/AddEditFormModal.component'

import * as authSelectors from '../../selectors/auth'
import * as estimatesSelectors from '../../selectors/estimates'

const propTypes = {
  estimateId: PropTypes.any,
  leadId: PropTypes.any
}
class LeadEstimates extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: -1,
      contentData: null
    }

    this.props.getAllItems()
    this.props.getAllVendors()
    this.props.getEstimateTemplates()
  }

  componentDidMount() {
    this.props.leadEstimatesRefresh({
      leadId: this.props.leadId,
      next: (err, payload) => {
        const { estimateId } = this.props
        if (estimateId) {
          if (!err) {
            const results = _.get(payload, 'data')
            const current = _.find(results, { id: estimateId })
            this.setState({
              contentData: current
            })
            this.props.getLeadEstimateSections(estimateId)
            this.props.getLeadEstimateItems(estimateId)
            this.props.getRevisions({
              targetId: estimateId,
              table: 'estimate'
            })
          }
        }
      }
    })
  }

  handleRowClick = (row, clone = false) => {
    const { leadId } = this.props
    this.props.getRevisions({
      targetId: row.id,
      table: 'estimate'
    })
    this.setState({
      currentId: row.id,
      contentData: { ...row }
    })

    if (clone) {
      history.push(`/lead/${leadId}/estimates/clone/${row.id}`)
    } else {
      history.push(`/lead/${leadId}/estimates/edit/${row.id}`)
    }

    this.props.getLeadEstimateSections(row.id)
    this.props.getLeadEstimateItems(row.id)
  }

  handleAddButton = () => {
    const { leadId } = this.props
    history.push(`/lead/${leadId}/estimates/add`)
    this.setState({
      currentId: 0,
      contentData: null
    })
  }

  handleClone = row => {
    this.handleRowClick(row, true)
  }

  changeContentData = (value, field) => {
    const tmpContentData = this.state.contentData
    tmpContentData[`${field}`] = value
    this.setState({
      contentData: tmpContentData
    })
  }

  render() {
    if (!this.props.leadEstimateActions.leadEstimates) {
      return <Loader />
    }

    const { leadId, estimateId } = this.props
    const { contentData } = this.state

    return (
      <div className="jobEstimate">
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'edit',
            leadId: leadId,
            estimateId: estimateId,
            contentData: contentData,
            changeContentData: this.changeContentData
          }}
          path={`/lead/:leadId/estimates/edit/:estimateId`}
          exact
        />
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'clone',
            leadId: leadId,
            estimateId: estimateId,
            contentData: contentData,
            changeContentData: this.changeContentData
          }}
          path={`/lead/:leadId/estimates/clone/:estimateId`}
          exact
        />
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'add',
            leadId: leadId,
            contentData: contentData,
            changeContentData: this.changeContentData
          }}
          path={`/lead/:leadId/estimates/add`}
          exact
        />
        <div className="jobsBar">
          Estimate
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              CREATE Estimate
            </div>
          </div>
        </div>
        {this.props.leadEstimateActions.leadEstimates && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: () => {
                if (column.Header !== 'Clone') {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={this.props.leadEstimateActions.leadEstimates.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'ID',
                    accessor: 'id',
                    maxWidth: 100
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    maxWidth: 170
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                    width: 160,
                    Cell: d => {
                      const r = `${d.original.created_by_first_name} ${
                        d.original.created_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Updated By',
                    id: 'updated_by',
                    accessor: d => d.updated_by_first_name + ' ' + d.updated_by_last_name,
                    width: 160,
                    Cell: d => {
                      const r = `${d.original.updated_by_first_name} ${
                        d.original.updated_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Grand Total',
                    id: 'grand_total',
                    accessor: d => numeral(d.grand_total).format('$0,0.00'),
                    maxWidth: 120,
                    className: 'textAlignRight'
                  },
                  {
                    Header: 'Clone',
                    accessor: 'clone',
                    Cell: d => (
                      <div>
                        <Popconfirm
                          title="Are you sure you want to make a copy of this Estimate?"
                          onConfirm={() => this.handleClone(d.original)}
                          onCancel={this.cancelDelete}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button
                            size="small"
                            icon="copy"
                            type="copy"
                            style={{ color: '#1F45B4' }}
                          />
                        </Popconfirm>
                      </div>
                    ),
                    width: 100
                  }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: 'id',
                desc: true
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  leadEstimateActions: state.leadEstimateActions,
  itemActions: state.itemActions,
  estimateTemplate: state.estimateTemplate,
  jobSiteChangeOrderActions: state.jobSiteChangeOrderActions,
  jobVendorActions: state.jobVendorActions,
  auditActions: state.auditActions,
  revisionActions: state.revisionActions,
  user: authSelectors.getUser(state, props),
  estimateId: estimatesSelectors.getEstimateIdParam(state, props)
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(
      {},
      itemActions,
      leadEstimateActions,
      estimateTemplateActions,
      jobSiteChangeOrderActions,
      jobVendorActions,
      revisionActions
    ),
    dispatch
  )
})
LeadEstimates.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeadEstimates))



// WEBPACK FOOTER //
// ./src/pages/lead/LeadEstimates.container.js